import { useDeleteCountry } from '../hooks/useDeleteCountry';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

interface DeleteCountryModalProps {
  countryId: string;
  countryName: string;
  open: boolean;
  onClose: () => void;
}

export function DeleteCountryModal({
  countryId,
  countryName,
  open,
  onClose,
}: DeleteCountryModalProps) {
  const { deleteCountry, isDeleting } = useDeleteCountry();

  const handleConfirm = () => {
    deleteCountry(countryId, {
      onSuccess: () => {
        Notification.success({ title: 'País eliminado exitosamente' });
        onClose();
      },
    });
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(v) => !v && onClose()}
      title="Eliminar país"
      description={
        <span data-testid="delete-country-confirmation-text">
          ¿Estás seguro de eliminar el país <strong>{countryName}</strong>?
        </span>
      }
      onConfirm={handleConfirm}
      confirmLabel="Eliminar"
      confirmLoadingLabel="Eliminando..."
      isPending={isDeleting}
      data-testid="delete-country-modal"
    >
      <div
        data-testid="delete-country-warning"
        className="p-3 bg-destructive/10 border border-destructive/30 rounded-md"
      >
        <p className="text-sm text-destructive font-medium">
          Esta acción es irreversible. Solo se puede eliminar si el país no tiene regiones ni
          territorios asociados.
        </p>
      </div>
    </ConfirmDialog>
  );
}
